import ActionType from "../../Actions/ActionType";
import { EmissionSettingsType } from "../../Actions/ProjectSettings/EmissionSettings";

const initialState = {
    isEmissionsEnabled: false,
};

const emissionSettingsReducer = (
  state = initialState,
  action: EmissionSettingsType
) => {
  switch (action.type) {
    case ActionType.EMISSION_SETTINGS:
      return {
        ...state,
        isEmissionsEnabled: action.data,
      };
    default:
      return state;
  }
};

export default emissionSettingsReducer;
